import React from "react";
import { CheckIcon } from "lucide-react";
import { finalIncludes } from "../../data/content";
import { CtaButton } from "../CtaButton";
import { Countdown } from "../Countdown";
export function FinalCta() {
  return <section className="bg-navy-deep pb-28 pt-16 text-white sm:pb-24 sm:pt-20" aria-labelledby="final-title" data-id="element-131" data-mp="1no6p2lzgmuwh">
      <div className="mx-auto max-w-2xl px-5 text-center" data-id="element-132" data-mp="1smhy4uhxl1dn">
        <p className="text-sm font-bold uppercase tracking-wider text-sky" data-id="element-133" data-mp="1ens2zkeo9brx">One last question…</p>
        <h2 id="final-title" className="mt-4 font-display text-[30px] font-black leading-tight sm:text-[42px]" data-id="element-134" data-mp="1iqelgupgdkcg">
          How much easier would it feel to prepare your next herniated disc case if you{" "}
          <em className="text-sky" data-id="element-135" data-mp="19ooyc12lt7kh">didn't have to start from a blank page?</em>
        </h2>
        <p className="mt-5 text-[17px] leading-relaxed text-white/75" data-id="element-136" data-mp="2z3myrkcoimlk">
          Not to tell you that every patient is the same. Not to replace your clinical judgment. But to give you a
          structured reference system you can adapt to the individual patient in front of you.
        </p>

        <p className="mt-8 font-display text-[72px] font-black leading-none text-white" data-id="element-137" data-mp="3tfo2l24dz7hi">$27</p>
        <p className="mt-1 text-sm font-bold uppercase tracking-wider text-white/60" data-id="element-138" data-mp="b16ujrw3d9wn">One time</p>

        <div className="mt-6" data-id="element-139" data-mp="703ep5e1ndvf">
          <CtaButton label="Get the Safe Spine Method™" tone="dark" caption="Instant Access · Lifetime Access · 7-Day Guarantee" data-id="element-140" data-mp="70wchgv0yt1f" />
        </div>

        <div className="mt-10" data-id="element-141" data-mp="3fhr8ccdend60">
          <Countdown tone="dark" data-id="element-142" data-mp="3ah3g5ndfwqa7" />
        </div>

        <div className="mt-10 rounded-3xl border border-white/15 p-6 text-left" data-id="element-143" data-mp="3aiekboass01u">
          <p className="text-center text-sm font-bold uppercase tracking-wider text-sky" data-id="element-144" data-mp="3oh4g90lvrtom">Get immediate access to</p>
          <ul className="mt-5 grid grid-cols-1 gap-3 sm:grid-cols-2" data-id="element-145" data-mp="3jfx7ozbwyqgw">
            {finalIncludes.map(item => <li key={item} className="flex items-center gap-3 text-[16px] font-semibold" data-id="element-146" data-mp="13rx8kf9do6im">
                <span className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-sky text-ink" data-id="element-147" data-mp="yt3rydysnze8">
                  <CheckIcon className="h-3.5 w-3.5" strokeWidth={3} aria-hidden="true" data-id="element-148" data-mp="1co9g9aibzzz" />
                </span>
                {item}
              </li>)}
          </ul>
        </div>

        <div className="mt-10" data-id="element-149" data-mp="5cgnv2ml10d9">
          <CtaButton label="Yes, I want the Safe Spine Method™" tone="dark" caption="Only $27 · One-Time Payment · Lifetime Access" data-id="element-150" data-mp="admfsy8f4jlq" />
        </div>

        <footer className="mt-16 border-t border-white/10 pt-8 text-sm text-white/50" data-id="element-151" data-mp="39uc9by0govj0">
          <p className="font-display text-lg font-bold text-white/80" data-id="element-152" data-mp="3dumkrq70we59">Safe Spine Method™</p>
          <p className="mt-2" data-id="element-153" data-mp="3irmohugeh4t7">© 2026 · Dr. Ryan Carter · Safe Spine Method™ · All Rights Reserved.</p>
          <p className="mx-auto mt-3 max-w-md text-xs" data-id="element-154" data-mp="3nlh34jh5etlf">
            Educational and organizational resource. It does not replace academic education, professional guidelines,
            clinical judgment, or individualized patient assessment.
          </p>
        </footer>
      </div>
    </section>;
}